import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  /* Outer padding */
  rootPadding: {
    padding: '24px 24px 24px 24px',
    boxSizing: 'border-box',
  },

  /* Title + content group */
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },

  title: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: 'rgba(43, 44, 53, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
  },

  /* Cards container */
  itemsWrap: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 5,
  },

  /* Card */
  card: {
    padding: 12,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minWidth: 250, // base ≥1441px
    border: '1px solid rgba(233, 235, 245, 1)',
    minHeight: 62,
  },

  /* Texts with ellipsis */
  fieldLabel: {
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '17px',
    color: 'rgba(95, 96, 113, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 0,
  },
  fieldValue: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '21px',
    color: 'rgba(146, 147, 166, 1)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    minWidth: 0,
  },

  /* ===== ≤1440px ===== */
  '@media (max-width:1440px)': {
    rootPadding: { padding: 22 },
    card: { minWidth: 240 },
    title: { fontSize: 13, lineHeight: '20px' },
    fieldLabel: { fontSize: 12 },
    fieldValue: { fontSize: 14, lineHeight: '20px' },
  },

  /* ===== ≤1280px ===== */
  '@media (max-width:1280px)': {
    rootPadding: { padding: 20 },
    card: { minWidth: 220 },
    title: { fontSize: 13, lineHeight: '20px' },
    fieldLabel: { fontSize: 11 },
    fieldValue: { fontSize: 13, lineHeight: '20px' },
  },

  /* ===== ≤1024px ===== */
  '@media (max-width:1024px)': {
    rootPadding: { padding: 16 },
    itemsWrap: { gap: 6 },
    card: { minWidth: 200, padding: 10 },
    title: { fontSize: 12, lineHeight: '18px' },
    fieldLabel: { fontSize: 11, lineHeight: '16px' },
    fieldValue: { fontSize: 12, lineHeight: '18px' },
  },
}));

export default useStyles;
